import { print } from 'graphql'

import { storefrontClient } from '../..'
import { RemoveAddressDocument, type RemoveAddressMutation } from '../../__generated/storefront'

export const removeAddress = () => async (token: string, addressId: string) => {
  const response = await storefrontClient.request<RemoveAddressMutation>(
    print(RemoveAddressDocument),
    {
      variables: {
        id: addressId,
        customerAccessToken: token,
      },
    },
  )

  const payload = response.data?.customerAddressDelete

  if (!payload?.deletedCustomerAddressId) {
    throw new Error('Failed to delete address')
  }

  return payload.deletedCustomerAddressId
}
